/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
export var StyledTableBottomControls = styled('div')(function () {
  return {
    '&.EmbersTableBottomControls-root': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      marginTop: 16,
      minHeight: 28,
      justifyContent: 'space-between',
      position: 'relative',
      '&>div': {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: '30%'
      },
      '&.with-load-more': {
        '.EmbersTable-RefreshIndicator-root': {
          flexGrow: 0
        }
      },
      '&.sm': {
        flexWrap: 'wrap',
        rowGap: 16,
        '&>div': {
          flexBasis: '100%',
          height: 32
        },
        '& .EmbersTable-LoadMore-root': {
          paddingRight: 0
        }
      },
      '&.word-break': {
        alignItems: 'baseline',
        '.EmbersTable-RefreshIndicator-root': {
          alignItems: 'baseline'
        }
      },
      '.EmbersTablePagination-root': {
        flexBasis: '40%'
      },
      '.EmbersTable-ResultsPerPage-root': {
        justifyContent: 'flex-end'
      }
    }
  };
});